<script setup>
import Layout from '../../Components/Shared/Layout.vue'
import FarmsCollection from '../../Components/Portfolio/FarmsCollection.vue';
import HarvestCollection from '../../Components/Portfolio/HarvestCollection.vue';
import ButtonComponent from '../../Components/Shared/ButtonComponent.vue';
import Map from '../../Components/Map/Map.vue'

import { computed } from "vue";

const props = defineProps(["farms","harvests"])
const farms_locations = computed(() => props.farms.map(item=>[item.lon,item.lat]))
const farms_areas_locations = computed(() => props.farms.map(item=>item.area.map(i=>[i.lon,i.lat])))
const harvests_areas_locations = computed(() => props.harvests.map(item=>item.area.map(i=>[i.lon,i.lat])))
const all_areas = computed(() => [...farms_areas_locations.value,...harvests_areas_locations.value])
</script>
<template lang="">
    <layout>
        <div class="container mx-auto text-center" v-if="farms.length==0">
            <h2 class="mx-auto mb-5 text-enriqueto_green mt-9">Crea tu portafolio</h2>
            <p class="w-2/3 m-auto ">Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non enim praesent elementum facilisis leo, vel fringilla est ullamcorper eget nulla facilisi etiam dignissim diam quis.</p>
            <div class=" flex justify-center">
                <ButtonComponent 
                content="Ingresa tu primera finca" 
                :icon="'add'"
                :link="'/portfolio/farm/create'"
                :normalLink="true"
                :newWindow="true"
                type="0"
                />
            </div>

            <img
                class="w-2/4 mx-auto my-6"
                src="/images/create_farm.png"
                alt=""
            />
        </div>
        <div class="container p-5 mx-auto mt-5" v-if="farms.length>0">
            <div class="flex justify-between w-full align-middle">
                <h2 class="mb-5 text-enriqueto_green mt-9">Mi Portafolio</h2>
                <div>
                    <ButtonComponent 
                        content="Nueva finca" 
                        :icon="'add'"
                        :link="'/portfolio/farm/create'"
                        :normalLink="true"
                        :newWindow="true"
                        type="0"
                        />
                </div>
            </div>
            <Map 
                :center="farms_locations[0]" 
                :locations="farms_locations"
                locations_icon="farm@2x.png"
                :locations_area="all_areas"
                :area="true"
                :id="'mapaFincas'"
                ></Map>
            <FarmsCollection :items="farms" />
            <HarvestCollection :items="harvests" />
        </div>
    </layout>
</template>
<style lang="">
    
</style>
